import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../utils/context";
import { MdClose } from "react-icons/md";
import { Box, Button } from "@mui/material";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { BsFileX, BsFillTrashFill } from "react-icons/bs";
import emptycart from "../../assets/emptycart.gif";
import cartloading from "../../assets/cartloading.gif";
import { enqueueSnackbar } from "notistack";

const Cart = ({ setCurrent }) => {
  const {
    handleRemoveFromCart,
    handleCartProductQuantity,
    cartSubTotal,

    cartItems,
    cartLoading,
    newOrder,
    setNewOrder,
  } = useContext(Context);

  let total = cartItems?.reduce((a, c) => (a += c.price * c.quantity), 0);

  const [couponCode, setCouponCode] = useState("");

  const handleApplyCoupon = () => {
    let value = couponCode;
    let coupens = [
      { coupen: "KUNAL12", value: 12 },
      { coupen: "KUNAL18", value: 18 },
      { coupen: "KUNAL20", value: 20 },
    ];
    let discount = coupens.find(
      (el) => el?.coupen?.toUpperCase() == value?.toUpperCase()
    );
    if (discount) {
      setNewOrder((prev) => ({
        ...prev,
        coupen_discount: discount.value,
        coupen_applied: discount.coupen,
        subtotal: total - (total * discount?.value) / 100,
      }));
      enqueueSnackbar("Coupen Applied Successfully", { variant: "success" });
    } else {
      enqueueSnackbar("Coupen Not Found", { variant: "warning" });
    }
  };
  const handleSubmit = () => {
    if (cartItems?.length === 0) {
      return enqueueSnackbar("Please add atleast one product", {
        variant: "warning",
      });
    }
    let subtotal = total;
    if (newOrder?.coupen_applied) {
      subtotal = total - (total * newOrder?.coupen_discount) / 100;
    }
    setNewOrder((prev) => ({
      ...prev,
      products: [...cartItems],
      total,
      subtotal,
    }));
    setCurrent((prev) => prev + 1);
  };
  return (
    <div className=" flex px-40 gap-5">
      <table className=" w-full mx-auto border-collapse border border-gray-300 mt-5">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2">IMAGE</th>
            <th className="p-2">PRODUCT NAME</th>
            <th className="p-2">PRICE</th>
            <th className="p-2">QUANTITY</th>
            <th className="p-2">TOTAL</th>
            <th className="p-2">REMOVE</th>
          </tr>
        </thead>
        <tbody>
          {cartLoading ? (
            <tr>
              <td colSpan={10}>
                <center>
                  <img width={"200px"} src={cartloading} />
                  <p style={{ fontSize: "20px" }}> Cart Loading</p>
                </center>
              </td>
            </tr>
          ) : cartItems?.length == 0 ? (
            <tr>
              <td colSpan={10}>
                <center>
                  <img width={"200px"} src={emptycart} />
                  <p style={{ fontSize: "20px" }}>Empty Cart</p>
                </center>
              </td>
            </tr>
          ) : (
            cartItems?.map((item) => (
              <tr key={item._id} className="border-b border-gray-300">
                <td className="p-2">
                  <div style={{ width: "100px" }}>
                    <img
                      src={item.images?.featuredImage?.src}
                      alt={item.name}
                      className="w-full h-full object-cover rounded"
                    />
                  </div>
                </td>
                <td className="p-2">{item.name}</td>
                <td className="p-6"> {"₹" + item.price}</td>
                <td className="p-2">
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "spacebetween",
                      alignItems: "center",
                    }}
                  >
                    <AiFillMinusCircle
                      fontSize={"18px"}
                      onClick={() => handleCartProductQuantity("dec", item)}
                    />

                    <span className="mx-2">{item.quantity}</span>

                    <AiFillPlusCircle
                      fontSize={"18px"}
                      onClick={() => handleCartProductQuantity("inc", item)}
                    />
                  </Box>
                </td>
                <td className="p-2"> {"₹" + item.price * item.quantity}</td>
                <td className="p-2">
                  <BsFillTrashFill
                    fontSize={"18px"}
                    className="cursor-pointer"
                    onClick={() => handleRemoveFromCart(item)}
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className=" w-1/2">
        <div className="   border-2 mt-5  flex flex-col justify-center    p-10 gap-8">
          <div className=" font-bold text-xl   ">CART TOTALS</div>
          <div className="apply-coupon">
            <h2>Apply Coupon</h2>
            <div className="coupon-input">
              <input
                style={{
                  border: "1px solid #ddd",
                  padding: "6.5px",
                  marginRight: "10px",
                }}
                type="text"
                placeholder="Enter coupon code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value?.toUpperCase())}
              />
              <Button variant="outlined" onClick={handleApplyCoupon}>
                Apply
              </Button>
            </div>
          </div>
          <div>
            TOTAL : <span>₹ {cartSubTotal}</span>
          </div>
          <div>
            {newOrder?.coupen_applied && (
              <div className="applied-coupon">
                Applied Coupon: {newOrder.coupen_applied} -{" "}
                {newOrder?.coupen_discount}% SUBTOTAL :{" "}
                <span> ₹ {newOrder?.subtotal}</span>
              </div>
            )}
          </div>
        </div>

        <button
          onClick={() => handleSubmit()}
          className=" items-center  w-full py-5 bg-[#FF8400] mt-10 text-white font-bold"
        >
          Proceed To Checkout
        </button>
      </div>
    </div>
  );
};

export default Cart;
